
import Moment from "moment";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentSummaryHistory } from "../../../../domain/document";

@Component
export default class DocumentArchiveIndicatorMixin extends Mixins() {
  @Prop({ default: null })
  selectedHistory: DocumentSummaryHistory;

  get isVisible(): boolean {
    return !!this.selectedHistory;
  }

  get title(): string {
    return this.isLatest
      ? "【最新文書表示中】"
      : "【過去文書表示中】";
  }

  get isLatest(): boolean {
    return this.selectedHistory && this.selectedHistory.isLatest;
  }

  get className(): string {
    return this.isLatest
      ? "document-archive-indicator-root-latest"
      : "document-archive-indicator-root-archive";
  }

  toString(toString: (h: DocumentSummaryHistory) => string): string {
    return this.selectedHistory
      ? toString(this.selectedHistory)
      : "";
  }

  get operatorName(): string {
    return this.toString(h => h.createOperatorName); 
  }

  get operatorProfessionName(): string {
    // 職種名は都度PscCommonから取っているため、以下のように文書を登録した時と異なる職種を表示することがあります。
    // 例1)有効期限切れ職員で文書を登録した場合：職種が取れず、空欄表示
    //     (Web.configでisExpiredUserEnable="true"なら有効期限切れ職員でもログイン可)
    // 例2)(あり得ないかもしれませんが)StaffテーブルのPublicIdが重複している場合：文書登録日時に有効だった職員の職種を表示
    return this.toString(h => h.createOperatorProfessionName);
  }

  get departmentName(): string {
    return this.toString(h => h.departmentName); 
  }

  get createdDate(): string {
    return this.toString(h => Moment(h.createDateTime).format("YYYY/MM/DD")); 
  }

  get createdTime(): string {
    return this.toString(h => Moment(h.createDateTime).format("HH:mm:ss")); 
  }

  get orderUserName(): string {
    return this.toString(h => h.orderUserName); 
  }

  get orderUserNameDescription(): string {
    return this.orderUserName
      ? "(指示:" + this.orderUserName + ")"
      : "";
  }

  get attendingUserName(): string {
    return this.toString(h => h.attendingUserName); 
  }

  get attendingUserNameDescription(): string {
    return this.attendingUserName
      ? "(指導:" + this.attendingUserName + ")"
      : "";
  }
}
